import { useState, useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import LandingPage from "./components/LandingPage";
import CommunityHub from "./components/CommunityHub";
import ProfilePage from "./components/ProfilePage";
import FirebaseConnectionTest from "./components/FirebaseConnectionTest";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<LandingPage />} />
          <Route path="/community/:userId" element={<CommunityHub />} />
          <Route path="/profile/:userId" element={<ProfilePage />} />
          <Route path="/firebase-test" element={<FirebaseConnectionTest />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
